import styled from 'styled-components';

export const NotificationAlertsRoot = styled.div`
  position: fixed;
  z-index: calc(var(--z-index-app-header) - 1);
  right: 0;
`;
